import { useLocalPref } from './useLocalPref';

export const CONVERSATION_PANEL_KEY = 'mdu.conversationOpen';

/** The sidebar is a fixed 360px, so it only fits beside a preview from `lg` up. */
export const WIDE_VIEWPORT_PX = 1024;

/**
 * Open/closed state for the file viewer's conversation sidebar, shared by the
 * viewer, the shared-link viewers and the editor so they agree.
 *
 * Comments are the point of the sidebar, not an easter egg behind a toolbar
 * icon — so it starts open and users discover it without hunting. Closing it
 * persists, so anyone who wants the full-width preview only says so once.
 *
 * The viewport check only picks the *first-visit* default: a phone can't spare
 * 360px next to the preview. localStorage is per-device, so phones start closed
 * and desktops start open without either overriding the other.
 */
export function useConversationPanel() {
  return useLocalPref(CONVERSATION_PANEL_KEY, window.innerWidth >= WIDE_VIEWPORT_PX);
}
